import { http } from '@/http/axios.js'
// 分页列表
export function getListAPI(params) {
  return http({
    url: '/admin/oprt/storeGoodsSeriesAd/page',
    method: 'get',
    params
  })
}
// 系列下拉（门店商品系列）
export function getSeriesListAPI(params) {
  return http({
    url: '/admin/storeGoodsSeries/enumList',
    method: 'get',
    params
  })
}
// detail
export function getDetailAPI(id) {
  return http({
    url: '/admin/oprt/storeGoodsSeriesAd/detail',
    method: 'get',
    params: { id }
  })
}
// add
export function addAPI(data) {
  return http({
    url: '/admin/oprt/storeGoodsSeriesAd/add',
    method: 'post',
    data
  })
}
// edit
export function editAPI(data) {
  return http({
    url: '/admin/oprt/storeGoodsSeriesAd/edit',
    method: 'post',
    data
  })
}
// 启用/禁用
export function changeStatusAPI(data) {
  return http({
    url: '/admin/oprt/storeGoodsSeriesAd/status/edit',
    method: 'post',
    data
  })
}
// 权重（独立端点，启用中也可调整）
export function changeWeightAPI(data) {
  return http({
    url: '/admin/oprt/storeGoodsSeriesAd/weight/edit',
    method: 'post',
    data
  })
}
// delete
export function deleteAPI(id) {
  return http({
    url: '/admin/oprt/storeGoodsSeriesAd/delete',
    method: 'post',
    data: { id }
  })
}
